import Backbone from 'backbone';

import Comment from '../model/comment';
import CommentView from './comment';
import FileUploadingBadge from './file.badge.uploading';
import View from './view';

import { is, yesterday, today } from '../utils/date';
import { diffuse } from '../utils/arrays';

export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );
    },

    events: {
        'click .comment--thumbnail': function({ currentTarget }) {
            const { fileId } = currentTarget.dataset;
            if (!fileId)
                return;

            this.trigger( 'gallery:open', fileId );
        },

        'click .--delivered .comment--reply-link': function({ currentTarget }) {
            const $commentEl = this.$( currentTarget ).closest( '.comment' );
            const { replyId, replyComment, replyUpdate_text, replyFio, replyDate } = $commentEl[0].dataset;

            const comment = new Comment( {
                type: 1,
                id: +replyId,
                comment: replyComment,
                update_text: replyUpdate_text,
                fio: replyFio,
                date: new Date( replyDate )
            } );

            this.trigger( 'reply:begin', comment );
        }
    },

    onBind(model) {
        this.loaded_ = {};
        this.options
            .collection.toJSON()
            .map( comment => comment.uuid )
            .map( uuid => [uuid, () => Backbone.$( `[data-uuid="${uuid}"]` ).parent()] )
            .forEach( ([uuid, $elfn]) => 
                this.loaded_[uuid] = Promise.resolve( $elfn ) );

        // those are channels
        const { commentsChannel, filesChannel } = this.options;
        if (!commentsChannel || !filesChannel)
            return;

        if (!this.filesChannel)
            this.filesChannel = filesChannel,
            filesChannel.forEach( uploading =>
                new FileUploadingBadge( { uploading } )
                    .render()
                    .then( view => view.$el.appendTo( this.$( '.comments-list' ) ) )
                    .then( () => this.trigger( 'list-modified' ) ) );

        commentsChannel.forEach( comment => {
            const uuid = comment.get( 'uuid' );
            const renderingComment = this.loaded_[uuid];

            // server received comment -> mark as received
            if (renderingComment)
                return renderingComment.then( $elfn => $elfn()
                    .find( '.comment' )
                    .addClass( '--delivered' )
                    [0].dataset.replyId = comment.id );

            // server not received comment -> prerender it
            const view = new CommentView();
            this.loaded_[uuid] = view.bind( comment )
                .then( (/*view*/) => view.$el.appendTo( this.$( '.comments-list' ) ) )
                .then( () => this.trigger( 'list-modified' ) )
                .then( () => () => view.$el );
        } );
    },

    serialize() {
        if (!this.model)
            return { comments: [] };

        // add fake date in the past to force adding separator
        // into the beginning of list
        let comments = [ makeSeparator( new Date( 0 ) ), 
            // reverse original list of comments
            // to get the last message in the end
            ...this.options.collection.toJSON().reverse() ];

        // automatically insert date separators between comments
        comments = diffuse( comments, (prev, next) => 
            is( prev.date, next.date )
                ? undefined
                : makeSeparator( next.date ) );
        // remove fake item in the beginning
        comments.shift();

        const td = today();
        const hasToday = comments
            .filter( comment => comment.separator )
            .some(separator => is( separator.date, td ) );

        if (!hasToday)
            // if there is no "today" mark:
            // it always must be added to the end of list
            // (see "fake item" above to know why)
            comments.push( makeSeparator( td ) );

        return { comments };
    }

} );

function makeSeparator(date) {
    let prefix = '';
    if (is( date, today() ))
        prefix = 'dates::today';
    else if (is( date, yesterday( today() ) ))
        prefix = 'dates::yesterday';

    let mask = date.getFullYear() === today().getFullYear()
        ? 'DofMonth'
        : 'DofMonthYYYY';

    return {
        separator: true,
        'caption-verbose': `${prefix}`,
        'caption-date-mask': mask,
        date: date
    };
}


// WEBPACK FOOTER //
// ./src/js/view/comment.list.js